import { WebStorageStateStore, UserManager } from 'oidc-client';

const rootUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
const userManagerConfig = {
  client_id: window.config.authentication.clientId,
  redirect_uri: `${rootUrl}/signin-oidc`,
  // We can uncomment this if we want the user to come back to the profile site after logout.
  // For now, we don't have a full loggedOut page implemented, so leaving this commented will have the user land on auth's logged out page.
  //post_logout_redirect_uri: `${rootUrl}/loggedOut`,
  response_type: 'code',
  scope: 'openid profile offline_access hcs-profile-api.user',
  authority: window.config.authentication.authority,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  accessTokenExpiringNotificationTime: 300,
  userStore: new WebStorageStateStore({ store: localStorage })
};

const userManager = new UserManager(userManagerConfig);

userManager.events.addUserSignedOut(() => {
  userManager.removeUser();
});

export default userManager;